/**************************************************
 * Nombre:       Formulario_Solicitud
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    EmailOutlined,
    FlagOutlined,
    PhoneAndroidOutlined,
    StorefrontOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSSOLICITUDES} from "../../Constantes";

const Formulario_Solicitud = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSSOLICITUDES.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre Completo'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={StorefrontOutlined} nombre={'Nombre del negocio'} dato={'negocio'} {...props}
                                  requerido={'El Nombre del negocio es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                  requerido={'El pais es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Numero Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={EmailOutlined} nombre={'Correo electronico'} dato={'correo'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={4} nombre={'Mensaje (opcional)'} dato={'mensaje'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Notas Internas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={4} nombre={'Notas Internas'} dato={'notas'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Solicitud